<template>
    <div>
        <v-autocomplete
            v-model="state"
            :items="states"
            item-value="id"
            item-text="name"
            :label="label"
            outlined
            dense
            :color="inputColor"
            :background-color="inputBackgroundColor"
            :readonly="readonly"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";
import {useCountryStateStore} from "@/stores/CountryState";

export default {
    name: "WStateAutocomplete",
    props: {
      value: [Number, Array],
      readonly: Boolean,
      label: String,
      rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, inputBackgroundColor} = useSharedData();

        const countryStateStore = useCountryStateStore();

        const state = ref(null);
        const states = ref([]);

        function findAll() {
            loading.value  = true;
            axios.get(`/countryStates`).then(response => {
                countryStateStore.setCountryStates(response.data);
                states.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
           state.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            countryStateStore,
            loading,
            inputColor,
            inputBackgroundColor,
            state,
            states,
            input,
        }
    }
}
</script>

<style scoped>

</style>